import "../../../static/js/loaders/jquery";

$('#file-js-example input[type=file]').on("change", function (event) {
  if (this.files.length > 0) {
    const fileName = $(this).siblings('.file-name')[0];
    fileName.textContent = "";

    for (let i = 0; i < this.files.length; i++) {
      fileName.textContent = fileName.textContent + this.files[i].name + " ";
    }

  }
});

let fileInputs = document.querySelectorAll("#file-js-example input[type=file]");
fileInputs.forEach(async input => {
  input.addEventListener("change", () => {
    var fileName = input.parentElement.querySelector(".file-name");
    fileName.innerHTML = input.files[0].name;
  });
});
